import React, { useMemo, useState } from 'react';
import { ModalView } from './styles/SelectExportCenters';
import SelectExportCentersView from './SelectExportCentersView';
import useCurrentUser from 'hooks/useCurrentUser';
import { useTranslation } from 'react-i18next';
import SuccessfulExportCentersView from './SuccessfulExportCentersView';

interface ExportDataModalProps {
  openModal: boolean;
  onCloseModal: (val: boolean) => void;
  selectedCenter: number | false;
}

const ExportDataModalView: React.FC<ExportDataModalProps> = ({
  openModal,
  onCloseModal,
  selectedCenter = false,
}) => {
  const [hasRequestedData, setHasRequestedData] = useState(false);
  const { user } = useCurrentUser();
  const { t } = useTranslation();
  const modalTitle = t(`settings:EXPORT_DATA.MODAL.${selectedCenter ? 'SINGLE_CENTER_HEADER' : 'MULTITPLE_CENTERS_HEADER'}`);
  const modalTitleProps = !hasRequestedData ? modalTitle : '';
  const viewProps = {
    multipleCenters: !selectedCenter,
    selectedCenter,
    t,
    email: user.email,
    user,
    onRequestData: setHasRequestedData,
    onCloseModal,
  };
  const CurrentView = useMemo(() => (
    !hasRequestedData
      ? <SelectExportCentersView {...viewProps} />
      : <SuccessfulExportCentersView {...viewProps} />
  ), [hasRequestedData, viewProps]);

  return (
    <>
      <ModalView
        title={modalTitleProps}
        openModal={openModal}
        onClosedModal={() => {
          onCloseModal(false);
        }}
      >
        {() => (
          <>
            {CurrentView}
          </>
        )}
      </ModalView>
    </>
  );
};

export default ExportDataModalView;
